import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { getStudentMentorGroups, getGuardianStudentGroup, getStudentEducationGroups } from 'actions/sections';
import { getContacts } from 'actions/conversation';
import { getSchoolData } from 'actions/user';
import { Spinner } from 'UI';
import { Button, Checkbox, Radio, Expandable, translate } from '@haldor/ui';
import './SelectRecipient.scss';
var SelectRecipientForm = /*#__PURE__*/function (_Component) {
  function SelectRecipientForm(props) {
    var _this;
    _classCallCheck(this, SelectRecipientForm);
    _this = _callSuper(this, SelectRecipientForm, [props]);
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (_this.props.selected == null) {
        return false;
      }
      if (_this.props.selected != prevProps.selected) {
        var foundInState = _this.state.sections.findIndex(function (section) {
          return (section === null || section === void 0 ? void 0 : section.id) == _this.props.selected;
        });
        if (foundInState < 0) {
          _this.setState({
            loadingGroups: true
          });
          _this.props.getGuardianStudentGroup(_this.props.activeStudent.id, _this.props.selected).then(function () {
            var _this$props$group;
            var selected = [];
            if (((_this$props$group = _this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.owners) != null) {
              selected = _this.props.group.owners;
            }
            _this.setState({
              loadingGroups: false,
              selected: JSON.parse(JSON.stringify(selected)),
              sections: [].concat(_toConsumableArray(_this.state.sections), [_this.props.group])
            });
          });
        } else {
          var selected = _this.state.sections[foundInState].owners;
          _this.setState({
            selected: JSON.parse(JSON.stringify(selected))
          });
        }
      }
    });
    _defineProperty(_this, "onGroupExpand", function (groupId, open) {
      // ALWAYS EMPTY SELECTED WHEN CHANGING GROUPS
      _this.setState({
        selected: []
      });
      var foundInState = _this.state.sections.findIndex(function (section) {
        return (section === null || section === void 0 ? void 0 : section.id) == groupId;
      });
      if (foundInState < 0 && !open) {
        _this.setState({
          loadingGroups: true
        });
        _this.props.getGuardianStudentGroup(_this.props.activeStudent.id, groupId).then(function () {
          _this.setState({
            loadingGroups: false,
            sections: [].concat(_toConsumableArray(_this.state.sections), [_this.props.group])
          });
        });
      }
    });
    /* Events */
    _defineProperty(_this, "submit", function (values) {
      var group = _this.state.sections.find(function (section) {
        return (section === null || section === void 0 ? void 0 : section.id) == _this.state.selectedGroupId;
      });
      var allOwnersSelected = _this.state.selected.length == group.owners.length;
      values.student = _this.props.activeStudent.id;
      values.memberships = [];
      values.relationships = [{
        referenceType: 'STUDENT',
        referenceId: _this.props.activeStudent.id
      }];
      if (!allOwnersSelected) {
        values.relationships.push({
          referenceType: 'SECTION',
          referenceId: group.id
        });
      }
      if (!allOwnersSelected) {
        _this.state.selected.forEach(function (member) {
          values.memberships.push({
            membershipID: member.id,
            membershipType: 'USER',
            permission: 'O',
            user: member
          });
        });
      } else {
        values.memberships.push({
          membershipID: group.id,
          membershipType: 'SECTION_OWNERS',
          permission: 'O',
          section: group
        });
      }
      if (_this.props.onSubmit) {
        _this.props.onSubmit(values);
      }
    });
    _defineProperty(_this, "onContactSelect", function (contact) {
      var selected = _this.state.selected;
      var found = selected.findIndex(function (selected) {
        return selected.id == contact.id;
      });
      if (found == -1) {
        selected.push(contact);
      } else {
        selected.splice(found, 1);
      }
      _this.setState({
        selected: selected
      });
    });
    _defineProperty(_this, "selectAllGroupContacts", function (groupOwners) {
      if (groupOwners != null) {
        if (_this.state.selected.length < (groupOwners === null || groupOwners === void 0 ? void 0 : groupOwners.length)) _this.setState({
          selected: []
        });
        groupOwners.forEach(function (owner) {
          _this.onContactSelect(owner);
        });
      }
    });
    /* Render methods */
    _defineProperty(_this, "renderGroup", function (group) {
      var _groupData, _groupData2;
      var _this$state = _this.state,
        selected = _this$state.selected,
        sections = _this$state.sections;
      var groupData = null;
      if (sections.length > 0) {
        groupData = sections.find(function (section) {
          return (section === null || section === void 0 ? void 0 : section.id) == group.id;
        });
      }
      var allSelected = false;
      if (groupData != null) {
        allSelected = _this.state.selected.length == groupData.owners.length;
      }
      if ((_groupData = groupData) !== null && _groupData !== void 0 && _groupData.owners && ((_groupData2 = groupData) === null || _groupData2 === void 0 ? void 0 : _groupData2.owners.length) > 0) {
        groupData.owners = _this.filterUsersByReferenceId(groupData.owners, groupData.schoolID.toString());
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "contact-list"
      }, groupData != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.50rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(c) {
          return _this.selectAllGroupContacts(groupData.owners);
        },
        label: _this.props.translate('Select all'),
        value: allSelected
      })), groupData.owners.map(function (owner) {
        var active = selected.findIndex(function (selected) {
          return selected.id == owner.id;
        }) > -1;
        return /*#__PURE__*/React.createElement("div", {
          className: "contact",
          key: owner.id,
          style: {
            marginLeft: '35px'
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: active,
          label: owner.firstName + ' ' + owner.lastName,
          onChange: function onChange() {
            return _this.onContactSelect(owner);
          }
        }));
      })) : /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }));
    });
    _this.state = {
      sections: [],
      selected: [],
      selectedGroupId: 0,
      loading: true,
      loadingGroups: false
    };
    return _this;
  }
  _inherits(SelectRecipientForm, _Component);
  return _createClass(SelectRecipientForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.getStudentMentorGroups(this.props.activeStudent.id);
      this.props.getStudentEducationGroups(this.props.activeStudent.id);
      this.props.getSchoolData(this.props.activeStudent.id, 'EnableGuardiansCommunication');
      this.props.getContacts(this.props.activeStudent.id).then(function () {
        _this2.setState({
          loading: false
        });
      });
    }
  }, {
    key: "hasNonStudentRole",
    value: function hasNonStudentRole(roles, referenceId) {
      return roles.some(function (role) {
        return role.referenceId === referenceId && role.roleId.toLowerCase() !== "student";
      });
    }
  }, {
    key: "filterUsersByReferenceId",
    value: function filterUsersByReferenceId(users, referenceId) {
      var _this3 = this;
      return users.filter(function (user) {
        return _this3.hasNonStudentRole(user.roles, referenceId);
      });
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger(group) {
      var _this4 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mentor';
      var selectedGroupId = this.state.selectedGroupId;
      return /*#__PURE__*/React.createElement("div", {
        className: "row-group"
      }, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "selected",
        input: {
          onChange: function onChange() {
            return _this4.handleGroupChange(group.id);
          },
          value: selectedGroupId
        },
        optionValue: group.id,
        label: group.title
      }), /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: type === 'mentor' ? {
          margin: 0
        } : {
          margin: 0,
          backgroundColor: '#FFF',
          border: '2px solid rgb(238, 238, 238)'
        }
      }, type === 'mentor' ? this.props.translate('Mentors') : this.props.translate('Teacher_0')));
    }
  }, {
    key: "handleGroupChange",
    value: function handleGroupChange(groupId) {
      this.setState({
        selectedGroupId: parseInt(groupId)
      });
      this.onGroupExpand(groupId);
    }
  }, {
    key: "renderGroupList",
    value: function renderGroupList(groups, type) {
      var _this5 = this;
      return groups.map(function (group) {
        return /*#__PURE__*/React.createElement(Expandable, {
          title: _this5.renderTrigger(group, type),
          key: group.id,
          open: parseInt(group.id) === parseInt(_this5.state.selectedGroupId),
          onChange: function onChange(open) {
            return _this5.handleGroupChange(group.id);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "contact-list"
        }, _this5.renderGroup(group)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var loading = this.state.loading;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        translate = _this$props.translate,
        mentorGroups = _this$props.mentorGroups,
        educationGroups = _this$props.educationGroups,
        schoolDatas = _this$props.schoolDatas;
      var filteredEducationGroups = [];
      if (Array.isArray(schoolDatas) && Array.isArray(educationGroups)) {
        filteredEducationGroups = educationGroups.filter(function (section) {
          return schoolDatas.some(function (setting) {
            var _setting$value;
            return setting.schoolId == section.schoolID && setting.key.toLowerCase() == "enableguardianscommunication" && ((_setting$value = setting.value) === null || _setting$value === void 0 ? void 0 : _setting$value.toLowerCase()) == "true";
          });
        });
      }
      if (loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "conversation participant-picker form-container"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation participant-picker form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, mentorGroups && this.renderGroupList(mentorGroups, 'mentor'), filteredEducationGroups && this.renderGroupList(filteredEducationGroups, 'education'), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.selected.length === 0 || this.state.loadingGroups
      }, translate('Select'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);
}(Component);
var FORM_NAME = 'SelectRecipientForm';
var selector = formValueSelector(FORM_NAME);
function mapStateToProps(state) {
  return {
    contacts: state.Conversation.contacts,
    activeStudent: state.User.activeStudent,
    students: state.guardians.students,
    translate: translate(state.Languages.translations),
    mentorGroups: state.groups.mentorGroups,
    educationGroups: state.groups.groups,
    group: state.groups.activeGroup,
    schoolDatas: state.User.schoolDatas,
    selected: selector(state, 'selected')
  };
}
export default connect(mapStateToProps, {
  getContacts: getContacts,
  getStudentMentorGroups: getStudentMentorGroups,
  getGuardianStudentGroup: getGuardianStudentGroup,
  getStudentEducationGroups: getStudentEducationGroups,
  getSchoolData: getSchoolData,
  change: change
})(reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true
})(SelectRecipientForm));